import Button from './Button';
import { GLASS_SURFACES } from '../../config/glassSurfaces';

const UNSELECTED_CHIP_CLASS = GLASS_SURFACES.secondaryButtons
  ? ''
  : 'border-gray-200 bg-white text-gray-700 dark:border-white/10 dark:bg-dark-card dark:text-dark-text';

// The Events page's quick-date look (Sam, 2026-10-13): short rounded pills on one line. The default chip is 44 px and wraps.
const PILL_CLASS = '!min-h-[36px] shrink-0 !whitespace-nowrap !rounded-full !px-3';
// The large pill: the festival day chips (Fri / Sat / Sun), the one filter on Sets and the lineup (Sam, 2026-10-26).
const PILL_LG_CLASS = '!min-h-[44px] shrink-0 !whitespace-nowrap !rounded-full !px-5 !text-base';

/**
 * Filter panel toggle chip — shared sizing/styling for Date, Sort, Genre, Type, etc.
 * `pill` gives the compact rounded chip the Events page and its Filters sheet use; `pill="lg"` the large one.
 */
export default function FilterChip({
  selected,
  onClick,
  children,
  className = '',
  pill = false,
  ...rest
}) {
  return (
    <Button
      type="button"
      variant={selected ? 'chipSelected' : 'secondary'}
      size="sm"
      onClick={onClick}
      className={`min-h-[44px] whitespace-normal rounded-lg text-sm font-semibold ${
        selected ? 'border' : UNSELECTED_CHIP_CLASS
      } ${pill === 'lg' ? PILL_LG_CLASS : pill ? PILL_CLASS : ''} ${className}`}
      {...rest}
    >
      {children}
    </Button>
  );
}
